import Link from "next/link";
import React from "react";

export default function PostsCard({
    imageUrl,
    tags,
    title,
    author,
    date,
    description,
    slugUrl,
}) {
    return (
        <Link href={`/blog/${slugUrl}`} className="article_card">
            <div className="article_image_container">
                <img alt={`Image de l'article ${title}`} src={imageUrl} />
                {/* <div className="duration_badge">
                    <img src="/clock.svg" alt="Horloge" className="clock_icon_duration" />
                    <span>{duration}</span>
                </div> */}
            </div>
            <div className="article_info_container">
                <h2 className="article_title">{title}</h2>

                <div className="article_info_desc">
                    <p className="article_author">écrit par <b>{author}</b></p>
                    <p className="article_date">{date}</p>
                </div>
                <div className="articles_tags_container">
                    <div className="articles_tags">
                        <p>{tags}</p>
                    </div>
                </div>

            </div>
        </Link>
    );
}